import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { EyeOff, Eye, User, Lock } from 'lucide-react';

function SignIn() {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login, getAccessToken } = useAuth();

  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      try {
        const token = await getAccessToken();
        if (token && isMounted) {
          navigate('/dashboard');
        }
      } catch (error) {
        console.error('인증 확인 중 오류 발생:', error);
      }
    };
    checkAuth();
    return () => {
      isMounted = false;
    };
  }, [navigate, getAccessToken]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const success = await login(userId, password);
    if (success) {
      navigate('/dashboard');
    } else {
      setError('로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.');
    }
  };

  return (
    <div className="flex h-screen items-center justify-center overflow-hidden bg-white">
      <div className="w-full max-w-md p-8">
        <div className="mb-[60px] flex justify-center">
          <img 
            src="/assets/images/hub_logo.png" 
            alt="KY HUB Console" 
            className="h-12"
          />
        </div>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="user-id" className="mb-1 block text-left text-sm font-medium text-headerBg">아이디</label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={20} />
                <input
                  id="user-id"
                  name="userId"
                  type="text"
                  required
                  className={`h-[60px] w-full rounded-3xl border border-gray-200 bg-gray-200 pl-10 pr-3 text-sm placeholder-[#A3A1A2] caret-black focus:border-primary focus:bg-primary focus:bg-opacity-10 focus:outline-none focus:ring-primary ${userId ? 'text-headerBg' : 'text-gray-500'}`}
                  placeholder="아이디를 입력해 주세요"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                />
              </div>
            </div>
            <div>
              <label htmlFor="password" className="mb-1 block text-left text-sm font-medium text-headerBg">비밀번호</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={20} />
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  required
                  className={`h-[60px] w-full rounded-3xl border border-gray-200 bg-gray-200 pl-10 pr-3 text-sm placeholder-[#A3A1A2] caret-black focus:border-primary focus:bg-primary focus:bg-opacity-10 focus:outline-none focus:ring-primary ${password ? 'text-headerBg' : 'text-gray-500'}`}
                  placeholder="비밀번호를 입력해 주세요"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {showPassword ? (
                  <Eye onClick={() => setShowPassword(false)} className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 opacity-40" size={20} />
                ) : (
                  <EyeOff onClick={() => setShowPassword(true)} className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 opacity-40" size={20} />
                )}
              </div>
            </div>
          </div>

          {error && (
            <div className="text-sm text-red-500">{error}</div>
          )}

          <div style={{ marginTop: '48px' }}>
            <button
              type="submit"
              disabled={!userId || !password}
              className={`h-[60px] w-full rounded-3xl text-lg font-bold text-white transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                !userId || !password 
                  ? 'cursor-not-allowed bg-primary-light opacity-50' 
                  : 'bg-primary hover:bg-primary-hover focus:ring-primary'
              }`}
            >
              로그인
            </button>
          </div>
        </form>
        <div className="mt-6 text-center text-sm">
          <span className="text-gray-600">아직 회원이 아니신가요? </span>
          <button
            type="button"
            onClick={() => navigate('/signup')}
            className="font-semibold text-black underline"
          >
            회원가입
          </button>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
